import { render, staticRenderFns } from "./ApprovalStageField.vue?vue&type=template&id=164df7af"
import script from "./ApprovalStageField.vue?vue&type=script&lang=js"
export * from "./ApprovalStageField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports